"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MaxLoopOverlay = void 0;

var _Button = require("../Button");

var _react = _interopRequireWildcard(require("react"));

var _reactRouter = require("react-router");

var _Tracker = require("../../util/Tracker");

var _urls = require("../../util/urls");

var _atoms = require("../../atoms");

var _VideoPlayer = require("../../organisms/VideoPlayer");

require("./MaxLoopOverlay.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Max Loop Overlay
var MaxLoopOverlay = function MaxLoopOverlay(_ref) {
  var _momentCollectionData;

  var acl = _ref.acl,
      saveUrl = _ref.saveUrl,
      loopCount = _ref.loopCount,
      showOverlay = _ref.showOverlay,
      playPressed = _ref.playPressed,
      maxLoopCount = _ref.maxLoopCount,
      allowAddToTraceiD = _ref.allowAddToTraceiD,
      videoContainerRef = _ref.videoContainerRef,
      momentCollectionData = _ref.momentCollectionData,
      onShare = _ref.onShare;

  var _useVideoSuspenders = (0, _VideoPlayer.useVideoSuspenders)(videoContainerRef),
      suspend = _useVideoSuspenders.suspend,
      resume = _useVideoSuspenders.resume;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      wasShowing = _useState2[0],
      setWasShowing = _useState2[1];

  var history = (0, _reactRouter.useHistory)();
  var isMomentAdded = momentCollectionData === null || momentCollectionData === void 0 ? void 0 : (_momentCollectionData = momentCollectionData.momentCollectionInfo) === null || _momentCollectionData === void 0 ? void 0 : _momentCollectionData.length;

  var onAddToTraceId = function onAddToTraceId(e) {
    if (isMomentAdded) {
      var momentInfo = momentCollectionData.momentCollectionInfo[0];
      window.location.href = (0, _urls.traceIdMomentUrl)(momentInfo.playlist_hash_key, momentInfo.collection_hash_key, momentInfo.user_playlist_clip_id, acl);
    } else {
      if (saveUrl.startsWith("http")) {
        window.location.href = saveUrl;
      } else {
        history.push(saveUrl);
      }
    }
  };

  var sharePressed = function sharePressed(e) {
    playPressed();

    if (typeof onShare === 'function') {
      onShare();
    }
  };

  if (!showOverlay && (!loopCount || loopCount < maxLoopCount)) {
    if (wasShowing) {
      resume();
      setWasShowing(false);
    }

    return null;
  }

  if (!wasShowing) {
    setWasShowing(true);
    suspend();
  } // debounce too many max loop tracks


  if (document.querySelector('.MaxLoopOverlay') == null) {
    (0, _Tracker.trackEvent)({
      action: 'Opened',
      element: document.querySelector('.MaxLoopOverlay *')
    });
  }

  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    trkContext: "Max Loop Overlay",
    className: "MaxLoopOverlay"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    center: true,
    content: "Still there?",
    type: _atoms.Label.Type.Heading3
  }), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    start: true,
    spacingTop: "5",
    spacingBottom: "5",
    spacingLeft: "4",
    spacingRight: "5"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    span: "1",
    trkAction: "Continue Pressed",
    onClick: function onClick() {
      return playPressed();
    },
    icon: _atoms.Icon.Type.Play,
    content: "Continue",
    marginRight: "10"
  }), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    span: "1",
    trkAction: "Share Pressed",
    onClick: sharePressed,
    icon: _atoms.Icon.Type.Action,
    marginRight: "10",
    content: "Share"
  }), allowAddToTraceiD && /*#__PURE__*/_react.default.createElement(_Button.Button, {
    span: "1",
    trkAction: "Add Trace ID Pressed",
    onClick: onAddToTraceId,
    icon: isMomentAdded ? _atoms.Icon.Type.TraceIDFilled : _atoms.Icon.Type.TraceIDEmpty,
    content: isMomentAdded ? "View on Trace iD" : "Add to my Trace iD"
  }))));
};

exports.MaxLoopOverlay = MaxLoopOverlay;
MaxLoopOverlay.defaultProps = {
  allowAddToTraceiD: true
};